<template>
  <b-container fluid>
    <b-row>
      <b-col class="d-flex align-items-start">
        <backlink class="mt-20" />
        <!-- Les actions occupent seules cette ligne : elles partageaient la largeur avec le
             titre, qui se comprimait un peu plus à chaque bouton ajouté — et le nom du produit,
             porté par le sous-titre, se retrouvait coupé. Le titre passe pleine largeur en
             dessous. -->
        <div v-if="values.id" class="flex-grow-1 text-right">
          <b-button variant="outline-primary" size="lg" @click="duplicateItem()">
            Dupliquer le produit
            <i class="far fa-copy fa-lg ml-10"></i>
          </b-button>
          <b-button variant="outline-primary ml-10" size="lg" @click="openFormModal(values.id, 'config')">
            Modifier la fiche
            <i class="far fa-pencil fa-lg ml-10"></i>
          </b-button>
          <b-button variant="outline-primary ml-10" size="lg" v-if="!config.hideActionPdfButton"
            @click="$root.exportPdf(exportPdfData)">
            Exporter en PDF
            <i class="far fa-file-alt fa-lg ml-10"></i>
          </b-button>
          <b-button v-if="rawValues.type == 'selling'" variant="outline-primary ml-10" size="lg"
            @click="$refs.movementModal.open(rawValues)">
            Enregistrer un mouvement de stock
            <i class="far fa-box-open fa-lg ml-10"></i>
          </b-button>
          <router-link
            v-if="rawValues.type == 'selling' && $root.isAuthorized('warehouse-transfer_new')"
            :to="{ name: 'WarehouseTransferForm', query: { product_id: values.id } }"
            class="btn btn-outline-primary btn-lg ml-10">
            Transférer vers un entrepôt
            <i class="far fa-exchange fa-lg ml-10"></i>
          </router-link>
          <!--
            Location pour compte : le formulaire tel que le client le remplira. L'aperçu plus
            bas montre les champs générés ; ce lien mène à la page réelle, avec son habillage
            boutique et ses champs communs.

            L'adresse vient de l'API : la boutique est servie sur un autre hôte que le
            back-office, le front ne peut pas la composer. Nouvel onglet — on quitte
            l'application pour un autre domaine, et la fiche reste ouverte derrière.
          -->
          <a v-if="rawValues.shop_request_url" :href="rawValues.shop_request_url" target="_blank"
            rel="noopener" class="btn btn-outline-primary btn-lg ml-10">
            Voir en boutique
            <i class="far fa-external-link fa-lg ml-10"></i>
          </a>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <h1 v-if="rawValues.type == 'selling'">
          Produit à la vente
          <div v-if="!isBusy" class="subtitle">#{{ values.name }}</div>
        </h1>
        <h1 v-else>
          Produit
          <div v-if="!isBusy" class="subtitle">#{{ values.name }}</div>
        </h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="mb-4">
            <span class="tag white-bg text-primary p-2 mr-2" v-for="tag in values.tags"  v-if="values.tags">
              <strong>#{{tag}}</strong>
            </span>
        </div>
      </b-col>
    </b-row>
    <div v-if="isBusy" class="loader"></div>
    <p v-if="isBusy" class="text-center">Les données sont en cours de chargement...</p>
    <b-row v-else>
      <b-col>
        <div class="ibox">
          <div class="ibox-content divided">
            <b-row v-if="rawValues.type == 'selling'">
              <b-col class="d-flex">
                <div class="pr-120">
                  <h3>{{ labels.sale_price }}</h3>
                </div>
                <div class="prices-list flex-grow-1 d-flex">
                  <div class="price flex-fill active">
                    <dl>
                      <dd>
                        {{ values.sale_price }}
                      </dd>
                    </dl>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="main-content">
              <b-col cols="6">
                <b-row>
                  <b-col cols="5" v-if="picture">
                    <img :src="picture" class="w-100" />
                  </b-col>
                  <b-col>
                    <dl>
                      <dt>{{ labels.internal_code }} :</dt>
                      <dd>{{ values.internal_code || "-" }}</dd>
                      <template v-if="rawValues.type == 'selling'">
                        <dt>{{ labels.purchase_price }} :</dt>
                        <dd>{{ values.purchase_price || "-" }}</dd>
                        <dt>{{ labels.supplier }} :</dt>
                        <dd>{{ values.supplier || "-" }}</dd>
                        <dt>{{ labels.brand }} :</dt>
                        <dd>{{ values.brand || "-" }}</dd>
                        <dt>{{ labels.model }} :</dt>
                        <dd>{{ values.model || "-" }}</dd>
                      </template>
                      <template v-else>
                        <dt>{{ labels.equipment_group }} :</dt>
                        <dd>{{ values.equipment_group || "-" }}</dd>
                        <dt>{{ labels.calibration_periodicity }} :</dt>
                        <dd>{{ values.calibration_periodicity || "-" }}</dd>
                        <dt>{{ labels.imputation_number }} :</dt>
                        <dd>{{ values.imputation_number || "-" }}</dd>
                      </template>
                      <dt>{{ labels.stock_mini }} :</dt>
                      <dd>{{ values.stock_mini || "-" }}</dd>
                      <dt>{{ labels.group_slug }} :</dt>
                      <dd>{{ values.group_slug || "-" }}</dd>
                      <dt>{{ labels.weight }} :</dt>
                      <dd>{{ values.weight || "-" }}</dd>
                      <dt>{{ labels.return_mode }} :</dt>
                      <dd>{{ values.return_mode || "-" }}</dd>
                      <dt>{{ labels.comment }} :</dt>
                      <dd class="nl2br">{{ values.comment || "-" }}</dd>
                    </dl>
                  </b-col>
                </b-row>
              </b-col>
              <b-col class="d-flex flex-column">
                <h3>Stockage</h3>
                {{ values.type }}
                <div v-if="rawValues.type == 'selling'" class="
                            storage_location
                            flex-grow-1
                            d-flex
                            flex-column
                            justify-content-center
                            flex-nowrap
                          ">
                  <b-badge :variant="rawValues.stock <= 0 ? 'danger' : 'success'">{{ labels.stock }} : {{
            rawValues.stock
          }}</b-badge>
                  <b-badge variant="warning">{{ labels.buffer_stock }} : {{ rawValues.stock - rawValues.buffer_stock
                    }}</b-badge>
                </div>
                <ul v-else-if="rawValues.type == 'renting'">
                  <li>
                    <b-badge :variant="rawValues.stock <= 0
            ? 'danger'
            : rawValues.stock <= rawValues.minimum_stock
              ? 'warning'
              : 'success'
            ">{{ labels.stock }} : {{ rawValues.stock }}
                    </b-badge>
                    <b-badge variant="warning">{{ labels.buffer_stock }} : {{ rawValues.stock - rawValues.buffer_stock
                      }}</b-badge>
                  </li>
                  <li>
                    <b-badge :variant="rawValues.stock > 0 ? 'success' : null">{{ rawValues.rent_count }}
                      {{ labels.rent_count ? labels.rent_count.toLowerCase() : null }}</b-badge>
                  </li>
                  <li>
                    <b-badge :variant="rawValues.maintenance_count > 0 ? 'warning' : 'success'">{{
            rawValues.maintenance_count
          }}
                      {{
              labels.maintenance_count ? labels.maintenance_count.toLowerCase() : null
            }}</b-badge>
                  </li>
                  <li>
                    <b-badge :variant="rawValues.lost_count > 0 ? 'danger' : 'success'">{{ rawValues.lost_count }}
                      {{ labels.lost_count ? labels.lost_count.toLowerCase() : null }}</b-badge>
                  </li>
                  <li>
                    <b-badge :variant="rawValues.trash_count > 0 ? 'danger' : 'success'">{{ rawValues.trash_count }}
                      {{ labels.trash_count ? labels.trash_count.toLowerCase() : null }}</b-badge>
                  </li>
                </ul>
              </b-col>
              <b-col class="d-flex flex-column barcode-col" v-if="rawValues.type == 'selling'">
                <h3>Code barre</h3>
                <b-row class="flex-grow-1 flex-column barcode-wrapper justify-content">
                  <div class="text-center">
                    <div>{{ rawValues.custom_bar_code ? rawValues.custom_bar_code : values.internal_code }}</div>
                  </div>
                  <div class="text-center">
                    <div>{{ values.name }}</div>
                  </div>
                  <barcode class="text-center" :value="values.custom_bar_code" :displayValue="false" height="50"
                    v-if="rawValues.custom_bar_code">Impossible de générer le code à barres</barcode>
                  <barcode class="text-center" :value="values.internal_code" :displayValue="false" height="50" v-else>
                    Impossible de générer le code à barres</barcode>
                </b-row>

                <b-row>
                  <b-col class="text-center bottom-link">
                    <a href @click.prevent="printBarcode()">
                      Imprimer
                      <i class="fa fa-chevron-right"></i>
                    </a>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row v-if="values.children_product">
              <b-col class="">
                <h3>Lot comprenant</h3>
                <div class="" v-for="child in values.children_product" :key="child.id">
                  <dl>
                    <dt>{{ rawValues.parent_product_type == 'product_lot' ? child.quantity : '-' }} <strong>{{
            child.product_child.name }}</strong> - {{ child.product_child.sale_price }} € / unité</dt>
                  </dl>
                </div>
              </b-col>
            </b-row>
            <b-row v-if="rawValues.type == 'selling'">
              <b-col cols="auto" class="indicator flex-fill">
                <div class="flex-grow-1">
                  <dl>
                    <dd>Produits vendus</dd>
                    <dt>quantité totale</dt>
                  </dl>
                </div>
                <h2>{{ totalQuantitySold }}</h2>
              </b-col>
              <b-col cols="auto" class="indicator flex-fill">
                <div class="flex-grow-1">
                  <dl>
                    <dd>Ventes</dd>
                    <dt>montant total HT</dt>
                  </dl>
                </div>
                <h2>{{ values.total_turnover }}</h2>
              </b-col>
              <b-col cols="auto" class="indicator flex-fill">
                <div class="flex-grow-1">
                  <dl>
                    <dd>Dépenses</dd>
                    <dt>montant total HT</dt>
                  </dl>
                </div>
                <h2>{{ values.total_cost }}</h2>
              </b-col>
              <b-col cols="auto" class="indicator flex-fill">
                <div class="flex-grow-1">
                  <dl>
                    <dd>Marge</dd>
                    <dt>brute</dt>
                  </dl>
                </div>
                <h2>
                  {{
            rawValues.total_turnover && rawValues.total_cost
              ? (
                parseFloat(rawValues.total_turnover) - parseFloat(rawValues.total_cost)
              ).toFixed(2)
              : 0
          }}€
                </h2>
              </b-col>
            </b-row>
            <!-- Tarification : sortie de la tête de fiche (la grille fait 5 paliers et
                 occupait trop de hauteur), placée juste avant les Applications. -->
            <b-row v-if="rawValues.type == 'renting'">
              <b-col>
                <h3>Tarification</h3>
                <PriceGrids :prices="rawValues.prices" show-single-label />
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <!-- Champs saisis en HTML au back-office (listes, indices, mise en forme),
                     déjà rendus tels quels en boutique (|raw) : on les interprète ici aussi,
                     sinon les balises s'affichent en clair. -->
                <h3>{{ labels.applications }}</h3>
                <div class="rich-text" v-html="values.applications || '-'"></div>
                <h3 class="mt-3">{{ labels.characteristics }}</h3>
                <div class="rich-text" v-html="values.characteristics || '-'"></div>
                <h3 class="mt-3">{{ labels.security_rules }}</h3>
                <div class="rich-text" v-html="values.security_rules || '-'"></div>
              </b-col>
              <b-col>
                <dl>
                  <dt>{{ labels.technical_sheet }} :</dt>
                  <dd v-if="technical_sheet">
                    <a :href="technical_sheet" target="_blank">{{ technical_sheet_name }}</a>
                  </dd>
                  <dd v-else>-</dd>
                  <dt>{{ labels.video }} :</dt>
                  <dd v-if="values.video">
                    <a :href="values.video" target="_blank">{{ values.video }}</a>
                  </dd>
                  <dd v-else>-</dd>
                </dl>
                <h3 class="mt-3">{{ labels.documents }}</h3>
                <ul>
                  <li v-for="document in documents" :key="document.id">
                    - <a :href="document.path" target="_blank">{{ document.file }}</a>
                  </li>
                </ul>
                <h3 class="mt-3">{{ labels.other_pictures }}</h3>
                <ul>
                  <li v-for="document in other_pictures" :key="document.id">
                    - <a :href="document.path" target="_blank">{{ document.file }}</a>
                  </li>
                </ul>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>

    <!--
      Location pour compte : aperçu du formulaire de demande.

      La fiche liste déjà les attributs activés, mais un nom d'attribut ne dit pas ce que le
      client verra : « Type de nacelle » peut être une liste déroulante de sept valeurs, une
      case à cocher, ou un champ libre. Le paramétrage se fait attribut par attribut, dans une
      bibliothèque de 163 entrées ; c'est ici qu'on lit le résultat.

      Les contrôles sont manipulables — sans quoi on ne peut pas dérouler une liste pour lire
      ses valeurs, ce qui est justement l'intérêt de l'aperçu. Rien n'est enregistré : les
      saisies vivent dans `previewValues`, un état local jeté au changement de fiche.
    -->
    <b-row v-if="!isBusy && rawValues.type == 'location_for_account'">
      <b-col>
        <div class="ibox">
          <div class="ibox-title">
            <i class="far fa-clipboard-list"></i>Aperçu du formulaire de demande
          </div>
          <div class="ibox-content">
            <p class="text-muted">
              Les champs générés par les attributs activés sur ce matériel, dans l'ordre où le
              client les verra. Les champs communs à toute demande — quantité, agence, affaire,
              chantier, dates, commentaire — ne sont pas repris ici : ils ne dépendent pas du
              paramétrage.
            </p>
            <p v-if="!requestAttributes.length" class="text-muted font-italic">
              Aucun attribut activé : la demande ne portera que les champs communs. Ils
              s'activent depuis « Modifier », champ « Attributs de demande ».
            </p>
            <b-row v-else>
              <b-col md="6" v-for="attribute in requestAttributes" :key="attribute.id" class="mb-4">
                <label class="font-bold mb-1">
                  {{ attribute.label }}<span v-if="attribute.required" class="text-danger">&nbsp;*</span>
                  <small v-if="attribute.unit" class="text-muted font-normal">({{ attribute.unit }})</small>
                </label>

                <!-- Choix unique : liste déroulante, comme en boutique. -->
                <b-form-select v-if="attribute.field_type == 'radio'" v-model="previewValues[attribute.id]"
                  :options="[{ value: null, text: 'Sélectionnez' }].concat(choiceList(attribute))" />

                <!-- Choix multiple : cases à cocher. -->
                <b-form-checkbox-group v-else-if="attribute.field_type == 'multiple_choice'"
                  v-model="previewValues[attribute.id]" :options="choiceList(attribute)" />

                <!-- Oui / Non : deux boutons radio, et un champ de valeur pour la variante. -->
                <template v-else-if="attribute.field_type == 'boolean' || attribute.field_type == 'boolean_number'">
                  <b-form-radio-group v-model="previewValues[attribute.id]" :options="['Oui', 'Non']" />
                  <b-form-input v-if="attribute.field_type == 'boolean_number'" type="number"
                    v-model="previewValues[attribute.id + '_value']"
                    class="mt-2" :placeholder="attribute.unit || 'Valeur'" />
                </template>

                <b-form-input v-else-if="attribute.field_type == 'number'" type="number"
                  v-model="previewValues[attribute.id]" :placeholder="attribute.unit || 'Valeur numérique'" />
                <b-form-input v-else-if="attribute.field_type == 'date'" v-model="previewValues[attribute.id]"
                  placeholder="jj/mm/aaaa" />
                <b-form-input v-else v-model="previewValues[attribute.id]" placeholder="Saisie libre" />

                <small class="text-muted">{{ fieldTypeLabel(attribute.field_type) }}</small>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
    </b-row>

    <!-- INC-002 : Répartition du stock par entrepôt -->
    <b-row v-if="!isBusy && stockByWarehouse.length">
      <b-col>
        <div class="ibox">
          <div class="ibox-title">
            <i class="far fa-warehouse"></i>Répartition du stock par entrepôt
          </div>
          <div class="ibox-content">
            <div class="table-wrapper">
              <b-table hover :items="stockByWarehouse" :fields="stockByWarehouseFields">
                <template slot="warehouse_name" slot-scope="data">
                  <!-- Ligne « Non affecté » (warehouse_id à null) : ni lien, ni code -->
                  <em v-if="!data.item.warehouse_id" class="text-muted">
                    {{ data.item.warehouse_name }}
                    <i class="far fa-exclamation-triangle" title="Références en stock sans entrepôt d'affectation"></i>
                  </em>
                  <template v-else>
                    <router-link v-if="$root.isAuthorized('warehouse_show')" :to="{
                      name: 'WarehouseDetail',
                      params: { id: data.item.warehouse_id },
                    }">{{ data.item.warehouse_name }}</router-link>
                    <span v-else>{{ data.item.warehouse_name }}</span>
                    <small class="text-muted">({{ data.item.warehouse_code }})</small>
                  </template>
                </template>
                <!-- Environnement de stockage du produit dans cet entrepôt -->
                <template slot="storage_environment" slot-scope="data">
                  <template v-if="data.item.warehouse_id">
                    <!-- Liste avec recherche : un entrepôt peut compter des dizaines d'environnements.
                         Sans v-model : modifier la ligne fait re-rendre la cellule par b-table, qui
                         détruirait le champ en cours d'émission. La ligne est mise à jour à l'enregistrement. -->
                    <div v-if="canEditStorage" :id="'storage-warehouse-' + data.item.warehouse_id" class="storage-autocomplete">
                      <OptionsAutocomplete :value="data.item.storage_environment_id" grouped :limit="500"
                        :options="storageEnvironmentOptions(data.item.warehouse_id)"
                        :placeholder="storageEnvironmentOptions(data.item.warehouse_id).length
                          ? 'Zone ou environnement…'
                          : 'Aucun environnement dans cet entrepôt'"
                        @input="(value) => saveStorage(data.item, value)" />
                    </div>
                    <template v-else-if="data.item.storage_environment_id">
                      <router-link v-if="$root.isAuthorized('storage-environment_show')" :to="{
                        name: 'StorageEnvironmentDetail',
                        params: { id: data.item.storage_environment_id },
                      }">{{ storageLabel(data.item) }}</router-link>
                      <span v-else>{{ storageLabel(data.item) }}</span>
                    </template>
                    <span v-else class="text-muted">-</span>
                  </template>
                </template>
                <template slot="available" slot-scope="data">
                  <!-- Location : un clic affiche les références en stock de cet entrepôt -->
                  <a v-if="canShowStockReferences(data.item)" href class="stock-link"
                    v-b-tooltip.hover title="Voir les références en stock dans cet entrepôt"
                    @click.prevent="showStockReferences(data.item)">
                    <b-badge variant="success">{{ data.item.available }} <i class="far fa-arrow-down"></i></b-badge>
                  </a>
                  <b-badge v-else :variant="!data.item.warehouse_id ? 'warning' : data.item.available <= 0 ? 'danger' : 'success'">{{ data.item.available }}</b-badge>
                </template>
                <template slot="reserved" slot-scope="data">
                  <b-badge :variant="data.item.reserved > 0 ? 'warning' : 'secondary'">{{ data.item.reserved }}</b-badge>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

    <!-- INC-009 : seuils d'alerte de stock par entrepôt -->
    <b-row v-if="!isBusy && thresholds.length && $root.isAuthorized('product_edit')">
      <b-col>
        <div class="ibox">
          <div class="ibox-title">
            <i class="far fa-bell"></i>Seuils d'alerte de stock par entrepôt
          </div>
          <div class="ibox-content">
            <p class="text-muted">Une alerte est levée lorsque le stock disponible passe au niveau ou en dessous du seuil. Laisser vide pour désactiver l'alerte sur un entrepôt.</p>
            <div class="table-wrapper">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>Entrepôt</th>
                    <th>Disponible</th>
                    <th>Seuil d'alerte</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in thresholds" :key="row.warehouse_id">
                    <td>{{ row.warehouse_name }} <small class="text-muted">({{ row.warehouse_code }})</small></td>
                    <td>
                      <!-- Code couleur de la répartition du stock : rouge en rupture ou sous le seuil, vert sinon -->
                      <b-badge :variant="row.available <= 0 || (row.stock_mini !== null && row.available <= row.stock_mini) ? 'danger' : 'success'">{{ row.available }}</b-badge>
                    </td>
                    <td>
                      <b-form-input type="number" min="0" v-model.number="row.stock_mini" style="max-width: 120px"></b-form-input>
                    </td>
                    <td>
                      <b-button size="sm" variant="primary" @click="saveThreshold(row)">Enregistrer</b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row v-if="rawValues.type == 'selling' && !isBusy">
      <!-- Affiché même sans mouvement : il porte le bouton d'ajout du premier -->
      <b-col>
        <div class="ibox">
          <div class="ibox-title d-flex align-items-center">
            <i class="far fa-wrench"></i>Historique des mouvements de stock
            <b-button size="sm" variant="outline-primary" class="ml-auto"
              @click="$refs.movementModal.open(rawValues)">
              Ajouter
            </b-button>
          </div>
          <div class="ibox-content">
            <p v-if="!rawValues.products_log || !rawValues.products_log.length" class="text-muted mb-0">
              Aucun mouvement de stock.
            </p>
            <div v-else class="table-wrapper">
              <b-table hover :fields="product_logs_fields" :items="rawValues.products_log" sort-by="id"
                :sort-desc="true">
                <template slot="order" slot-scope="data">
                  <router-link v-if="data.item.renting" :to="{
            name: renting_config.detailRouteName,
            params: { id: data.item.renting.id },
          }">{{ data.item.renting.renting_number }}</router-link>
                  <span v-else-if="data.item.order_number">{{ data.item.order_number }}</span>
                  <span v-else>Mouvement manuel</span>
                </template>
                <template slot="warehouse" slot-scope="data">
                  <span v-if="data.value" v-b-tooltip.hover :title="data.value.name">{{ data.value.internal_code }}</span>
                  <span v-else class="text-muted">—</span>
                </template>
                <template slot="status" slot-scope="data">
                  <b-badge variant="primary">{{
            data.value.status_slug == "product-add-stock" ? "Entrée" : "Sortie"
          }}</b-badge>
                </template>
                <template slot="purchase_price" slot-scope="data">{{
              data.value ? parseFloat(data.value).toFixed(2) + "€" : null
            }}</template>
                <template slot="sale_price" slot-scope="data">{{
              data.value ? parseFloat(data.value).toFixed(2) + "€" : null
            }}</template>
                <template slot="created_at" slot-scope="data">{{
              data.value | moment("DD-MM-YYYY")
            }}</template>
                <template slot="pdf" slot-scope="data">
                  <b-button v-b-tooltip.hover title="Exporter la commande en PDF" variant="outline-secondary"
                    v-if="data.item.renting && data.item.renting.id"
                    @click.prevent="exportPdfSingle(data.item.renting)">
                    <i class="far fa-file-alt"></i>
                  </b-button>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row v-if="!isBusy">
      <b-col v-if="rawValues.related_products && rawValues.related_products.length">
        <div class="ibox">
          <div class="ibox-title"><i class="far fa-toolbox"></i>{{ labels.related_products }}</div>
          <div class="ibox-content">
            <div class="table-wrapper">
              <b-table hover :fields="related_products_fields" :items="rawValues.related_products">
                <template slot="name" slot-scope="data">
                  <router-link :to="{ name: 'ProductDetail', params: { id: data.item.id } }">{{
            data.value
          }}</router-link>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row v-if="rawValues.type == 'renting' && !isBusy">
      <b-col v-if="rawValues.unique_references && rawValues.unique_references.length">
        <div class="ibox" id="product-references">
          <div class="ibox-title"><i class="far fa-wrench"></i>Références uniques</div>
          <div class="ibox-content">
            <!-- Filtre posé depuis la répartition du stock : les contrôles de filtre ne sont
                 affichés qu'au-delà de 10 références, le bandeau dit ce qui est filtré. -->
            <div v-if="referencesFocusActive" class="references-focus">
              <i class="far fa-filter"></i>
              Références en stock à <strong>{{ referencesFocus.label }}</strong>
              ({{ filteredReferencesItems.length }})
              <a href class="ml-auto" @click.prevent="clearReferencesFocus">Voir toutes les références</a>
            </div>
            <!-- Un produit MCS porte jusqu'à ~11 000 matériels : tout rendre d'un coup
                 allongeait la fiche à plusieurs milliers de lignes. Pagination reprise
                 d'AdminTable (mêmes paliers, même compteur) pour ne pas dépayser. -->
            <b-row class="references-filters" v-if="showReferencesPagination">
              <b-col cols="12" md>
                <b-form-group label="Recherche" class="mb-0">
                  <b-input-group>
                    <b-form-input id="filter-references-search" v-model="referencesSearch"
                      placeholder="N° interne, marque, modèle…" />
                    <b-input-group-append v-if="referencesSearch">
                      <b-button @click="referencesSearch = ''">
                        <i class="far fa-times"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="3" v-if="referencesWarehouses.length > 1">
                <b-form-group label="Entrepôt" class="mb-0">
                  <b-form-select id="filter-references-warehouse" v-model="referencesWarehouse"
                    :options="referencesWarehouseOptions" />
                </b-form-group>
              </b-col>
              <b-col md="3" v-if="referencesStatuses.length > 1">
                <b-form-group label="Statut" class="mb-0">
                  <b-form-select id="filter-references-status" v-model="referencesStatus"
                    :options="referencesStatusOptions" />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Affichage" class="mb-0">
                  <b-form-select id="filter-references-per-page" v-model="referencesPerPage"
                    :options="referencesPerPageOptions" />
                </b-form-group>
              </b-col>
            </b-row>
            <div class="table-wrapper">
              <b-table hover show-empty :fields="referenceTableFields" :items="filteredReferencesItems"
                :current-page="referencesCurrentPage" :per-page="parseInt(referencesPerPage)">
                <template slot="empty">
                  <div class="text-center my-2">Aucun matériel ne correspond à cette recherche</div>
                </template>
                <template slot="internal_code" slot-scope="data">
                  <router-link :to="{ name: 'ReferenceDetail', params: { id: data.item.id } }">{{
            data.value
          }}</router-link>
                </template>
                <template slot="status" slot-scope="data">
                  <b-badge variant="primary">{{ data.value }}</b-badge>
                </template>
                <!-- Transfert inter-entrepôts du matériel de la ligne, prérempli comme depuis
                     sa fiche. Indisponible hors stock : le bouton reste, désactivé, et le
                     tooltip dit pourquoi — l'absence pure et simple laisserait chercher.
                     Tooltip à gauche : la colonne touche le bord droit, au-dessus il sortirait
                     de la fenêtre. -->
                <template slot="transfer" slot-scope="data">
                  <router-link v-if="!transferDisabledReason(data.item)" v-b-tooltip.hover.left
                    title="Transférer vers un entrepôt"
                    :to="{ name: 'WarehouseTransferForm', query: transferQuery(data.item) }"
                    class="btn btn-outline-secondary">
                    <i class="far fa-exchange"></i>
                  </router-link>
                  <span v-else v-b-tooltip.hover.left :title="transferDisabledReason(data.item)"
                    class="d-inline-block" tabindex="0">
                    <b-button variant="outline-secondary" disabled style="pointer-events: none">
                      <i class="far fa-exchange"></i>
                    </b-button>
                  </span>
                </template>
              </b-table>
            </div>
            <template v-if="showReferencesPagination">
              <div class="total float-right">
                {{ parseInt(referencesPerPage) < filteredReferencesItems.length ? referencesPerPage :
                filteredReferencesItems.length }} / <strong>{{ filteredReferencesItems.length }}</strong>
                  résultats
              </div>

              <b-pagination class="mb-0" align="center" size="sm" :total-rows="filteredReferencesItems.length"
                :per-page="parseInt(referencesPerPage)" v-model="referencesCurrentPage" />
            </template>
          </div>
        </div>
      </b-col>
    </b-row>

    <b-row v-if="rawValues.type == 'renting' && !isBusy">
      <b-col v-if="rawValues.product_companies && rawValues.product_companies.length">
        <div class="ibox">
          <div class="ibox-title"><i class="far fa-building"></i>Organismes d'étalonnage</div>
          <div class="ibox-content">
            <div class="table-wrapper">
              <b-table hover :fields="product_companies_fields" :items="rawValues.product_companies">
                <template slot="name" slot-scope="data">
                  <router-link :to="{ name: 'CompanyDetail', params: { id: data.item.company_id } }">{{
                    data.item.company_name
                    }}</router-link>
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

    <AdminModalForm v-if="config.useEditModal" :config="config" :id_to_edit="id_to_edit" />
    <StockMovementModal ref="movementModal" @saved="onMovementSaved" />
  </b-container>
</template>

<script>
import config, { esmPrice } from "./config";
import renting_config from "@/components/Renting/config";
import reference_config from "@/components/Reference/config";
import AdminModalForm from "@/components/Global/AdminModalForm";
import PriceGrids from "@/components/Global/PriceGrids";
import StockMovementModal from "./StockMovementModal";
import barcodeLabel from "@/mixins/barcodeLabel";
import { environmentLabel, environmentGroupedOptions } from "@/components/StorageEnvironment/labels";

export default {
  name: "ProductDetail",
  mixins: [barcodeLabel],
  components: {
    AdminModalForm,
    PriceGrids,
    StockMovementModal,
  },
  data() {
    return {
      config: config,
      renting_config: renting_config,
      reference_config: reference_config,
      labels: {},
      reference_fields: [],
      // Pagination des références uniques (côté client : la liste est déjà dans la
      // réponse de la fiche). Mêmes paliers que la liste générique AdminTable.
      referencesCurrentPage: 1,
      referencesSearch: "",
      referencesWarehouse: null,
      // Filtre posé par un clic sur une quantité disponible : { warehouse, status, label }.
      referencesFocus: null,
      referencesStatus: null,
      referencesPerPage: 20,
      referencesPerPageOptions: {
        10: "10 par page",
        20: "20 par page",
        50: "50 par page",
        100: "100 par page",
        999999999: "Tout afficher",
      },
      related_products_fields: [],
      stockByWarehouse: [], // INC-002 : répartition du stock par entrepôt
      thresholds: [], // INC-009 : seuils d'alerte de stock par entrepôt
      // Saisies de l'aperçu du formulaire de demande, indexées par attribut. Purement local :
      // rien n'est envoyé, rien n'est relu — c'est un bac à sable pour dérouler les listes et
      // voir le rendu réel des champs.
      previewValues: {},

      product_logs_fields: [
        { key: "quantity", label: "Quantité" },
        { key: "order", label: "Commande" },
        { key: "status", label: "Type" },
        { key: "warehouse", label: "Entrepôt" },
        { key: "comment", label: "Commentaire" },
        { key: "purchase_price", label: "Prix d'achat unitaire HT" },
        { key: "sale_price", label: "Prix de vente" },
        { key: "created_at", label: "Date" },
        { key: "pdf", label: "PDF" },
      ],
      historic_fields: [
        { key: "number", label: "Numéro" },
        { key: "status", label: "Statut" },
      ],
      product_companies_fields: [
        { key: "name", label: "Nom" }
      ],
      isBusy: false,
      id_to_edit: null,
      lists: [],
      lists_fields: {},
    };
  },
  computed: {
    /**
     * Une location pour compte n'entre jamais en stock : pas d'environnement de stockage.
     */
    hasStorage: function () {
      return this.rawValues.type && this.rawValues.type != "location_for_account";
    },
    canEditStorage: function () {
      return this.hasStorage && this.$root.isAuthorized("product_edit") && this.$root.isAuthorized("storage-environment_index");
    },
    stockByWarehouseFields: function () {
      return [
        { key: "warehouse_name", label: "Entrepôt" },
        ...(this.hasStorage ? [{ key: "storage_environment", label: "Environnement de stockage" }] : []),
        { key: "available", label: "Quantité disponible" },
        { key: "reserved", label: "Quantité réservée" },
      ];
    },
    rawValues: function () {
      return this.$store.getters[config.storeNamespace + "/getItem"](this.$route.params.id) || {};
    },
    values: function () {
      return this.$root.formatData(
        this.rawValues,
        this.config.fields.filter((field) => field.inDetail == true)
      );
    },
    /**
     * Attributs activés sur ce matériel, résolus depuis la bibliothèque.
     *
     * `request_attribute_ids` arrive déjà dans l'ordre d'affichage du formulaire boutique :
     * l'API le construit à partir des liens produit↔attribut, pas d'un tri sur l'identifiant.
     * On garde cet ordre — l'aperçu n'aurait aucune valeur s'il montrait autre chose que la
     * séquence réelle. Un identifiant sans correspondance est écarté plutôt qu'affiché en
     * ligne vide : il désigne un attribut supprimé de la bibliothèque.
     */
    requestAttributes() {
      return (this.rawValues.request_attribute_ids || [])
        .map((id) => this.$store.getters["request_attribute/getItem"](id))
        .filter(Boolean);
    },
    picture() {
      return this.rawValues.picture
        ? process.env.BACK_FILES_URL + this.rawValues.picture.file
        : null;
    },
    technical_sheet_name() {
      return this.rawValues.technical_sheet ? this.rawValues.technical_sheet.file : null;
    },
    technical_sheet() {
      return this.rawValues.technical_sheet
        ? process.env.BACK_FILES_URL + this.rawValues.technical_sheet.file
        : null;
    },
    documents() {
      return this.rawValues.documents
        ? this.rawValues.documents
            .filter((document) => document.type_slug == "product-document")
            .map((document) => ({
              ...document,
              path: process.env.BACK_FILES_URL + document.file,
            }))
        : null;
    },
    other_pictures() {
      return this.rawValues.documents
        ? this.rawValues.documents
            .filter((document) => document.type_slug == "product-other-picture")
            .map((document) => ({
              ...document,
              path: process.env.BACK_FILES_URL + document.file,
            }))
        : null;
    },
    totalQuantitySold() {
      if (this.rawValues.products_log) {
        var filtredLogs = this.rawValues.products_log.filter(
          (log) =>
            log.renting && log.status.status_slug == "product-remove-stock" && log.sale_price > 0
        );
        if (filtredLogs.length) {
          return Math.abs(
            filtredLogs
              .map((log) => log.quantity)
              .reduce((accumulator, currentValue) => accumulator + currentValue)
          );
        }
      }
      return 0;
    },
    listsItems: function () {
      let listsItems = {};
      if (this.lists && this.lists.length) {
        this.lists.forEach((list) => {
          if (this.values[list.name]) {
            listsItems[list.name] = this.$root.formatDatas(
              this.values[list.name],
              list.config.fields
            );
          }
        });
      }
      return listsItems;
    },
    // Les contrôles n'apparaissent qu'au-delà du plus petit palier : en deçà, il n'y a
    // rien à paginer, et les masquer sous le palier courant enfermerait « Tout afficher ».
    showReferencesPagination: function () {
      return this.referencesItems.length > 10;
    },
    // Entrepôts et statuts réellement représentés dans la liste, avec le nombre de matériels
    // que chacun détient — pour l'entrepôt, le même chiffre que la répartition du stock plus
    // haut. Construits depuis les lignes plutôt que depuis le référentiel : proposer une
    // valeur que ce produit ne porte pas ne mènerait qu'à un tableau vide.
    referencesWarehouses: function () {
      return this.countReferencesBy("current_warehouse");
    },
    referencesStatuses: function () {
      return this.countReferencesBy("status");
    },
    referencesFocusActive: function () {
      return Boolean(
        this.referencesFocus &&
          this.referencesWarehouse === this.referencesFocus.warehouse &&
          this.referencesStatus === this.referencesFocus.status
      );
    },
    referencesWarehouseOptions: function () {
      return [{ value: null, text: "Tous les entrepôts" }].concat(this.referencesWarehouses);
    },
    referencesStatusOptions: function () {
      return [{ value: null, text: "Tous les statuts" }].concat(this.referencesStatuses);
    },
    // Colonnes du tableau : les champs de la config, plus la colonne d'action de transfert
    // pour qui a le droit d'en créer un. Elle reste hors de `reference_fields`, sur lequel
    // s'appuie la recherche : il n'y a rien à chercher dans une colonne de boutons.
    referenceTableFields: function () {
      if (!this.$root.isAuthorized("warehouse-transfer_new")) {
        return this.reference_fields;
      }

      return this.reference_fields.concat([{ key: "transfer", label: "", class: "text-right" }]);
    },
    // Lignes brutes indexées par identifiant : le tableau affiche des valeurs formatées
    // (« En stock », « LG3 »), le transfert a besoin du slug de statut et de l'identifiant
    // de l'entrepôt.
    rawReferencesById: function () {
      const byId = {};
      (this.rawValues.unique_references || []).forEach((reference) => {
        byId[reference.id] = reference;
      });

      return byId;
    },
    filteredReferencesItems: function () {
      const search = this.referencesSearch.trim().toLowerCase();

      return this.referencesItems.filter(
        (item) =>
          (!this.referencesWarehouse || item.current_warehouse == this.referencesWarehouse) &&
          (!this.referencesStatus || item.status == this.referencesStatus) &&
          (!search || this.referenceMatches(item, search))
      );
    },
    referencesItems: function () {
      return this.rawValues.unique_references
        ? this.$root.formatDatas(
            this.rawValues.unique_references,
            this.reference_config.fields.filter((field) => field.inDetail == true)
          )
        : [];
    },
    exportPdfData: function () {
      let exportPdfData = {
        title: this.config.pdf_export_title
          ? this.config.pdf_export_title(this.rawValues, this.values, this)
          : this.values[this.config.titleField],
        link: this.config.pdf_export_link
          ? this.config.pdf_export_link(this.rawValues, this.values, this)
          : null,
        infos: [],
      };

      if (this.config.pdf_export_logo) {
        exportPdfData.logo = this.config.pdf_export_logo;
      }

      if (this.config.pdf_export_extra_content_before) {
        exportPdfData.extra_content_before = this.config.pdf_export_extra_content_before(
          this.rawValues,
          this.values,
          this
        );
      }

      if (this.config.pdf_export_custom_main_content) {
        exportPdfData.custom_main_content = this.config.pdf_export_custom_main_content(
          this.rawValues,
          this.values,
          this
        );
      } else {
        this.config.fields
          .filter((field) => field.inPdfExport == true)
          .forEach((field) => {
            exportPdfData.infos.push([
              field.label + " :",
              field.type == "yesno"
                ? this.values[field.name] == true
                  ? "Oui"
                  : "Non"
                : this.values[field.name] || null,
            ]);
          });
      }

      exportPdfData.lists = [];
      if (this.lists && this.lists.length) {
        this.lists.forEach((list) => {
          if (this.listsItems[list.name]) {
            let currentList = {
              label: list.label,
              infos: [this.lists_fields[list.name].map((f) => f.label)],
            };
            this.listsItems[list.name].forEach((item) => {
              let infosItem = [];
              list.fields.forEach((field) => {
                infosItem.push(item[field] || null);
              });
              currentList.infos.push(infosItem);
            });
            exportPdfData.lists.push(currentList);
          }
        });
      }

      if (this.config.pdf_export_extra_lists) {
        exportPdfData.lists.push(
          ...this.config.pdf_export_extra_lists(this.rawValues, this.values, this)
        );
      }

      if (this.config.pdf_export_extra_content_after) {
        exportPdfData.extra_content_after = this.config.pdf_export_extra_content_after(
          this.rawValues,
          this.values,
          this
        );
      }

      return exportPdfData;
    },
  },
  watch: {
    // Filtrer réduit la liste : rester sur la page 7 d'un tableau qui n'en compte plus que
    // deux afficherait un tableau vide, sans que rien n'explique pourquoi.
    referencesWarehouse: function () {
      this.referencesCurrentPage = 1;
    },
    referencesStatus: function () {
      this.referencesCurrentPage = 1;
    },
    referencesSearch: function () {
      this.referencesCurrentPage = 1;
    },
    /**
     * Prépare une entrée par attribut dans `previewValues`.
     *
     * Vue 2 ne rend pas réactives les clés ajoutées après coup à un objet : sans cette
     * amorce, `v-model="previewValues[attribute.id]"` écrirait bien la valeur, mais l'écran
     * ne bougerait pas. On réassigne donc un objet complet — toutes ses clés naissent
     * observées. Un tableau pour un choix multiple, null pour le reste ; `_value` porte le
     * nombre associé à un « Oui / Non + valeur ».
     */
    requestAttributes: {
      immediate: true,
      handler(attributes) {
        const values = {};
        attributes.forEach((attribute) => {
          values[attribute.id] = attribute.field_type == "multiple_choice" ? [] : null;
          if (attribute.field_type == "boolean_number") {
            values[attribute.id + "_value"] = null;
          }
        });
        this.previewValues = values;
      },
    },
    // Changer de palier depuis une page haute retomberait sur une page vide (page 40
    // n'existe plus en « 100 par page ») : on revient au début, comme AdminTable.
    referencesPerPage: function () {
      this.referencesCurrentPage = 1;
    },
  },
  beforeDestroy() {
    this.$root.$off("bv::modal::hidden", this.onModalHidden);
  },
  mounted() {
    this.$root.$on("bv::modal::hidden", this.onModalHidden);

    // Réouverture de la modale si l'URL porte déjà l'édition : lien partagé, favori, ou
    // simple rafraîchissement.
    this.$nextTick(() => {
      const editId = this.$route.query.edit;
      if (editId && config.useEditModal && this.$root.isAuthorized(config.authFeature + "_edit")) {
        this.openFormModal(parseInt(editId));
      }
    });

    // Chargement des champs à afficher dans le détail depuis la config
    // Et récupération des libellés
    config.fields
      .filter((field) => field.inDetail == true)
      .forEach((field) => {
        this.labels[field.name] = field.label;
      });

    this.isBusy = true;
    this.$store
      .dispatch(config.storeNamespace + "/getItem", {
        id: this.$route.params.id,
        wait: true,
      })
      .then(() => {
        // Test si le contenu demandé est bien trouvé
        let self = this;
        if (Object.entries(this.rawValues).length <= 2) {
          this.$toastr.error(
            "La fiche demandée n'a pas été trouvée. Assure-vous que l'URL saisie soit correcte."
          );
          setTimeout(function () {
            self.$router.go(-1);
          }, 5000);
          return;
        }
        if (this.canEditStorage) {
          this.$store.dispatch("storage_environment/getAllForSelect");
        }
        // La fiche ne porte que les identifiants des attributs activés : la bibliothèque est
        // nécessaire pour en tirer un libellé, un type et des valeurs. Chargée seulement pour
        // une location pour compte — c'est la seule nature qui en active. `getOptions` sert le
        // vocabulaire des types de champ.
        if (this.rawValues.type == "location_for_account") {
          this.$store.dispatch("request_attribute/getAll");
          this.$store.dispatch("request_attribute/getOptions");
        }
        this.isBusy = false;

        // ?movement=<id> : la modale de mouvement de stock est rouverte au chargement
        if (this.$route.query.movement) {
          if (this.rawValues.type == "selling" && this.$route.query.movement == String(this.rawValues.id)) {
            this.$refs.movementModal.open(this.rawValues);
          } else {
            this.$refs.movementModal.setInUrl(null);
          }
        }
      });

    // INC-002 : récupération de la répartition du stock par entrepôt
    this.loadStockByWarehouse();

    // INC-009 : seuils d'alerte de stock par entrepôt
    this.loadThresholds();

    // Gestion des listes additionnelles
    this.lists = this.config.fields.filter((field) => field.type == "list");
    if (this.lists && this.lists.length) {
      let lists_fields = {};
      this.lists.forEach((list) => {
        lists_fields[list.name] = [];

        list.fields.forEach((field) => {
          lists_fields[list.name].push({
            key: field,
            label: list.config.fields.find((f) => f.name == field).label,
          });
        });
      });
      this.lists_fields = lists_fields;
    }

    // Préparation des champs pour les listes des références
    let reference_fields = reference_config.fields
      .filter((field) =>
        this.config.fields
          .find((field) => field.name == "unique_references" && field.inDetail == true)
          .fields.includes(field.name)
      )
      .map((field) => ({
        key: field.name,
        label: field.label,
      }));
    this.reference_fields = reference_fields;

    // Préparation des champs pour les listes des produits associés
    let related_products_fields = this.config.fields
      .filter((field) =>
        this.config.fields
          .find((field) => field.name == "related_products" && field.inDetail == true)
          .fields.includes(field.name)
      )
      .map((field) => ({
        key: field.name,
        label: field.label,
      }));
    this.related_products_fields = related_products_fields;
  },
  methods: {
    /**
     * Après un mouvement de stock : la fiche (historique, stock) est rechargée par la modale,
     * restent la répartition par entrepôt et les seuils d'alerte, qui ont leurs propres appels.
     */
    onMovementSaved() {
      this.loadStockByWarehouse();
      this.loadThresholds();
    },
    storageEnvironmentOptions(warehouseId) {
      return environmentGroupedOptions(this.$store.getters["storage_environment/getAll"], warehouseId);
    },
    storageLabel(row) {
      return environmentLabel(row, false);
    },
    /**
     * Enregistre l'environnement de stockage du produit dans un entrepôt (vide = aucun).
     */
    saveStorage(row, storageEnvironmentId) {
      if ((storageEnvironmentId || null) == (row.storage_environment_id || null)) {
        return;
      }
      this.$http
        .patch(
          process.env.BACK_API_URL + "product/" + this.$route.params.id + "/storage/" + row.warehouse_id,
          null,
          { params: { storage_environment_id: storageEnvironmentId || "" } }
        )
        .then(() => {
          const environment = this.$store.getters["storage_environment/getItem"](storageEnvironmentId);
          this.$set(row, "storage_environment_id", storageEnvironmentId || null);
          this.$set(row, "storage_environment_name", environment ? environment.name : null);
          this.$set(row, "storage_zone_name", environment && environment.storage_zone ? environment.storage_zone.name : null);
          this.$toastr.success("Environnement de stockage mis à jour pour " + row.warehouse_name + ".");
        })
        .catch((error) => {
          const message = error.response && error.response.data && error.response.data.message;
          this.$toastr.error(message || "Échec de la mise à jour de l'environnement de stockage.");
          this.loadStockByWarehouse();
        });
    },
    loadStockByWarehouse() {
      this.$http
        .get(process.env.BACK_API_URL + "product/" + this.$route.params.id + "/stocks/by-warehouse")
        .then((response) => {
          // L'API omet les champs nuls : une ligne sans emplacement arrive sans
          // `storage_environment_id`. Clé déclarée d'emblée, sans quoi la renseigner ensuite ne
          // serait pas réactive (Vue 2) et le champ resterait vide jusqu'au rechargement.
          this.stockByWarehouse = (response.data.distribution || []).map((row) => ({
            storage_environment_id: null,
            storage_environment_name: null,
            storage_zone_name: null,
            ...row,
          }));
        })
        .catch(() => {
          this.stockByWarehouse = [];
        });
    },
    /**
     * Query de préremplissage du formulaire de transfert, celle de la fiche matériel :
     * la source est l'entrepôt où se trouve le matériel.
     */
    transferQuery(item) {
      const reference = this.rawReferencesById[item.id] || {};
      const query = {
        reference_id: item.id,
        internal_code: reference.internal_code,
      };
      if (reference.current_warehouse && reference.current_warehouse.id) {
        query.source_warehouse_id = reference.current_warehouse.id;
      }

      return query;
    },
    /**
     * Raison rendant le transfert indisponible (null si possible) — la règle de la fiche
     * matériel : seul un matériel en stock est quelque part, donc transférable.
     */
    transferDisabledReason(item) {
      const status = (this.rawReferencesById[item.id] || {}).status || {};
      if (status.status_slug === "reference-en-stock") return null;
      if (status.status_slug === "reference-en-location") {
        return "Référence en location : effectuez d'abord un retour avant de pouvoir la transférer.";
      }
      const label = status.name ? `« ${status.name} »` : "actuel";

      return `Transfert impossible : seules les références en stock peuvent être transférées (statut ${label}).`;
    },
    /**
     * La saisie est cherchée dans les colonnes affichées, celles que l'utilisateur a sous
     * les yeux : n° interne, fournisseur, marque, modèle, statut, entrepôt. Les mots comptent
     * séparément et dans n'importe quel ordre — « bosch perceuse » trouve une perceuse de
     * marque Bosch quelle que soit la colonne qui porte chaque mot.
     */
    referenceMatches(item, search) {
      const haystack = this.reference_fields
        .map((field) => item[field.key])
        .join(" ")
        .toLowerCase();

      return search.split(/\s+/).every((word) => haystack.includes(word));
    },
    /**
     * Valeurs distinctes prises par un champ dans la liste des références, chacune avec son
     * effectif, triées pour que l'ordre du menu ne dépende pas de celui des lignes.
     * Les lignes sans valeur (un matériel en location n'est dans aucun entrepôt) sont ignorées :
     * elles n'ont pas d'entrée à proposer.
     */
    /**
     * Références en stock d'un entrepôt, telles que le tableau les affiche. Les filtres
     * comparent des valeurs formatées : on les reprend d'une référence en stock de cet
     * entrepôt plutôt que de les reconstruire.
     */
    stockReferenceSample(row) {
      return this.referencesItems.find((item) => {
        const raw = this.rawReferencesById[item.id];
        return (
          raw &&
          raw.status &&
          raw.status.status_slug == "reference-en-stock" &&
          raw.current_warehouse &&
          raw.current_warehouse.id == row.warehouse_id
        );
      });
    },
    canShowStockReferences(row) {
      return this.rawValues.type == "renting" && row.warehouse_id && row.available > 0 && Boolean(this.stockReferenceSample(row));
    },
    /**
     * Filtre le tableau des références sur celles en stock dans l'entrepôt de la ligne,
     * puis y fait défiler la page.
     */
    showStockReferences(row) {
      const sample = this.stockReferenceSample(row);
      if (!sample) {
        return;
      }
      this.referencesSearch = "";
      this.referencesWarehouse = sample.current_warehouse;
      this.referencesStatus = sample.status;
      this.referencesFocus = {
        warehouse: sample.current_warehouse,
        status: sample.status,
        label: row.warehouse_name + (row.warehouse_code ? " (" + row.warehouse_code + ")" : ""),
      };
      this.$nextTick(() => {
        const table = document.getElementById("product-references");
        if (table) {
          table.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    },
    clearReferencesFocus() {
      this.referencesWarehouse = null;
      this.referencesStatus = null;
      this.referencesFocus = null;
    },
    countReferencesBy(key) {
      const counts = {};
      this.referencesItems.forEach((item) => {
        if (item[key]) {
          counts[item[key]] = (counts[item[key]] || 0) + 1;
        }
      });

      return Object.keys(counts)
        .sort()
        .map((value) => ({ value: value, text: value + " (" + counts[value] + ")" }));
    },
    /**
     * Valeurs proposées d'un attribut. Elles sont stockées en texte, une par ligne
     * (cf. `RequestAttribute::getChoiceList()` côté serveur, qui découpe de la même façon
     * pour monter le formulaire boutique).
     */
    choiceList(attribute) {
      return (attribute.choices || "")
        .split("\n")
        .map((choice) => choice.trim())
        .filter(Boolean);
    },
    // Libellé lisible d'un type de champ : « Choix unique », « Oui / Non »… Le vocabulaire
    // vient de l'API, il n'est pas recopié dans le front.
    fieldTypeLabel(type) {
      return this.$store.getters["request_attribute/getFieldTypeLabel"](type);
    },
    // INC-009 : seuils d'alerte de stock par entrepôt
    loadThresholds() {
      this.$http
        .get(process.env.BACK_API_URL + "product/" + this.$route.params.id + "/thresholds/by-warehouse")
        .then((response) => {
          this.thresholds = response.data.thresholds || [];
        })
        .catch(() => {
          this.thresholds = [];
        });
    },
    saveThreshold(row) {
      this.$http
        .patch(
          process.env.BACK_API_URL + "product/" + this.$route.params.id + "/threshold/" + row.warehouse_id,
          null,
          { params: { stock_mini: row.stock_mini === null || row.stock_mini === "" ? "" : row.stock_mini } }
        )
        .then(() => {
          this.$toastr.success("Seuil mis à jour pour " + row.warehouse_name + ".");
        })
        .catch(() => {
          this.$toastr.error("Échec de la mise à jour du seuil.");
        });
    },
    /**
     * Ouvre la modale d'édition et le signale dans l'URL.
     *
     * Sans ce report, l'état d'édition n'existe que dans la mémoire de l'onglet : un
     * rafraîchissement le perd, et le lien envoyé à un collègue ouvre la fiche en lecture.
     * `AdminTableSync` le fait déjà pour les listes ; la fiche s'aligne dessus, avec le même
     * nom de paramètre.
     */
    openFormModal(id, config) {
      this.id_to_edit = id;
      this.syncEditToUrl(id);
      this.$root.$emit("bv::show::modal", "admin_modal_form");
    },
    /** Retire le paramètre à la fermeture : l'URL doit décrire ce qui est à l'écran. */
    onModalHidden(bvEvent, modalId) {
      if (modalId === "admin_modal_form") {
        this.id_to_edit = null;
        this.syncEditToUrl(null);
      }
    },
    syncEditToUrl(id) {
      const query = { ...this.$route.query };
      if (id) {
        query.edit = String(id);
      } else {
        delete query.edit;
      }
      // `replace` et non `push` : ouvrir puis fermer la modale ne doit pas empiler deux
      // entrées d'historique, sans quoi « Précédent » la rouvrirait.
      if (JSON.stringify(query) !== JSON.stringify(this.$route.query)) {
        this.$router.replace({ query: query }).catch(() => {});
      }
    },
    /**
     * Change le statut de la demande pour 'En attente de traitement'
     */
    duplicateItem() {
      // Création d'une copie en retirant les champs uniques et en récupérant les id des relations
      let copy = {
        ...this.rawValues,
        equipment_group_id: this.rawValues.equipment_group ? this.rawValues.equipment_group.id : null,
        supplier_id: this.rawValues.supplier ? this.rawValues.supplier.id : null,
        calibration_provider_id: this.rawValues.calibration_provider
          ? this.rawValues.calibration_provider.id
          : null,
        status_id: this.rawValues.status ? this.rawValues.status.id : null,
        picture_id: this.rawValues.picture ? this.rawValues.picture.id : null,
        picture: this.rawValues.picture ? this.rawValues.picture.file : null,
        other_pictures: this.rawValues.documents
          ? this.rawValues.documents.filter((document) => document.type_slug == "product-other-picture")
          : [],
        technical_sheet_id: this.rawValues.technical_sheet ? this.rawValues.technical_sheet.id : null,
        technical_sheet: this.rawValues.technical_sheet ? this.rawValues.technical_sheet.file : null,
        documents: this.rawValues.documents
          ? this.rawValues.documents.filter((document) => document.type_slug == "product-document")
          : [],
        related_products: this.rawValues.related_products ? this.rawValues.related_products : [],
        product_companies: this.rawValues.product_companies ? this.rawValues.product_companies.map(pc => ({...pc, id: null})) : [],
        sale_price_1: esmPrice(this.rawValues, "range1"),
        sale_price_2: esmPrice(this.rawValues, "range2"),
        sale_price_3: esmPrice(this.rawValues, "range3"),
        sale_price_4: esmPrice(this.rawValues, "range4"),
        sale_price_5: esmPrice(this.rawValues, "range5"),
        stock_mini: this.rawValues.stock_mini ? this.rawValues.stock_mini : "0",
        parents: this.rawValues.parent_product ? this.rawValues.parent_product.map(item => ({
          ...item,
          product_parent_id: item.product_parent.id
        })) : [],
        return_mode: this.rawValues.return_mode ? this.rawValues.return_mode : null,
        name : this.rawValues.parent_product && this.rawValues.parent_product.length ? this.rawValues.name.replace(this.rawValues.parent_product.find(parent => parent.child_product_type === 'product_variation').product_parent.name+' - ', '') : this.rawValues.name
      };
      copy.id            = null;
      copy.internal_code = null;

      // On stoque la copie dans le store pour la récupérer ensuite dans le formulaire
      this.$store.commit("product/prepareCopy", copy);

      // Ouverture du formulaire de création qui sera pré-rempli
      this.openFormModal(null, "config");
    },
    printBarcode() {
      this.printBarcodeLabel();
    },
  },
};
</script>

<style lang="scss">
// Quantité disponible cliquable de la répartition du stock (location).
.stock-link .badge {
  cursor: pointer;

  i {
    margin-left: 4px;
    font-size: 8px;
  }
}

.stock-link:hover .badge {
  background-color: #1aae7c;
  color: #fff;
}

// Bandeau du filtre posé depuis la répartition du stock.
.references-focus {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 15px;
  padding: 10px 16px;
  background-color: #e0f9ec;
  font-size: 12px;

  a {
    text-decoration: underline;
  }
}

// Colonne « Environnement de stockage » de la répartition : assez large pour lire « Zone > Environnement ».
// Largeur fixe : à l'ouverture, la recherche et le menu ne doivent pas élargir la colonne.
.storage-autocomplete {
  width: 480px;
  max-width: 480px;
}

@import "~@/assets/scss/_variables.scss";

.barcode-wrapper> :nth-child(1) {
  font-size: 22px;
}

// Filtres du tableau des références : champs de la charte, libellé au-dessus, comme le
// formulaire de transfert inter-entrepôts. En colonnes plutôt qu'en ligne — au-delà de deux
// filtres, l'alignement horizontal les tassait. Aucune surcharge de label ni de largeur :
// c'est la grille qui donne la largeur, et le style maison fait le reste. La recherche ouvre
// la ligne et prend la place restante jusqu'au premier select — les colonnes masquées (un
// seul entrepôt, un seul statut) lui reviennent, plutôt que de laisser un blanc à gauche.
.references-filters {
  margin-bottom: 20px;

  // Croix d'effacement de la recherche : celle de la barre de recherche des listes, pas un
  // bouton plein — elle prolonge le champ au lieu de lui répondre.
  .input-group-append .btn {
    color: $text-50p;
    background: none;
    border: solid 1px $border-10p;
    border-left: none;
  }
}

// Contenu HTML saisi au back-office (applications, caractéristiques, règles de sécurité).
.rich-text {
  ul,
  ol {
    padding-left: 18px;
    margin-bottom: 0;
  }

  p:last-child {
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Product/ProductDetail.vue